(function () {
    "use strict";

    angular.module("app").filter("habilRequestUrl", HabilRequestUrlFilterFactory);

    HabilRequestUrlFilterFactory.$inject = ["settingsService", "habilRequestPages",];
    function HabilRequestUrlFilterFactory(settingsService, habilRequestPages,) {
        const pageUrlConfigs = {
            installationRequest: {
                pages: {
                    default: "Request",
                },
                route: habilRequestPages.physicalSecurity,
                urlBuilder: getUrl,
            },
            externalInstallationRequest: {
                pages: {
                    default: "ExternalRequest",
                },
                route: habilRequestPages.physicalSecurity,
                urlBuilder: getUrl,
            },
            installationScreening: {
                pages: {
                    default: "Screening",
                },
                route: habilRequestPages.physicalSecurity,
                urlBuilder: getUrl,
            },
            externalInstallationScreening: {
                pages: {
                    default: "ExternalScreening",
                },
                route: habilRequestPages.physicalSecurity,
                urlBuilder: getUrl,
            },
            psc: {
                pages: {
                    default: "ViewOnly",
                },
                route: habilRequestPages.psc,
                urlBuilder: getLegacyUrl,
            },
            fsc: {
                pages: {
                    default: "ViewOnly",
                },
                route: habilRequestPages.fsc,
                urlBuilder: getLegacyUrl,
            },
        };

        return function (id, requestType) {
            const config = pageUrlConfigs[requestType];
            if (!config) {
                console.error("No pageUrlConfig found for", requestType);
                return;
            }

            if (!config.route) {
                console.error("No route configured for", requestType);
                return;
            }

            const page = config.pages.default;
            return config.urlBuilder(config.route, page, id);
        };

        function getUrl(routePrefix, page, id) {
            return `${settingsService.applicationPath}${routePrefix}/${page}/${id}`;
        }

        function getLegacyUrl(routePrefix, page, id) {
            return `${settingsService.applicationPath}${routePrefix}/${page}/?requestId=${id}`;
        }
    }
})();